import React, { useState} from "react";
import {
  Grid,
  Button,
  TextField,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import { GET_CLIENT_UUID } from "../../graphQL/client_qry";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
     "& .MuiOutlinedInput-root": {
      backgroundColor: "#EFEFEF",

      "& fieldset": {
        borderColor: "#999999",
      },

      "&:hover fieldset": {
        borderColor: "#999999",
      },

      "&.Mui-focused fieldset": {
        borderColor: "#999999",
        borderWidth: "1px",
      },
    },

    "& .MuiInputLabel-root": {
      color: "#000000",
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: "#000000",
    },
  },  
  selectStyle: {
    minWidth: 200,
    height: 35,
    paddingRight: 16,
    marginBottom: 25,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

export default function ViewNoteDialog({
  closeDialog,
  fullName,
  userUuid,
  termUuid,
  termName,
  termTeams,
  termRoles,
  completed,
  applyNextTerm,
  note,
  noteUpdateBy,
  noteUpdateDate,
  teamTermMemberIds
}) {
  let termsList = [];
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part  
  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  
  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null 
                      ? 
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;    
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        " " +
        dayFormat.find((a) => a.type == "hour").value +
        ":" +
        dayFormat.find((a) => a.type == "minute").value +
        ":" +
        dayFormat.find((a) => a.type == "second").value +
        " " +
        dayFormat.find((a) => a.type == "dayPeriod").value;

      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1100px",
              height: "700px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Member Term Notes
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
            <b>Member:</b> {fullName}
          </Typography>
          <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
            <b>Term:</b> {termName}
          </Typography>
          <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
            <b>Team: </b>
             {termTeams.length === 1 ? (
              <>
                {termTeams[0]} / {termRoles[0]}
              </>
              ) : (
            <Select
              className={classes.selectStyle}
              defaultValue={teamTermMemberIds[0]}
              margin="normal"
              // onChange={handleChangeValue}
            >
              {termTeams.map((team, index) => (
                <MenuItem key={index} value={teamTermMemberIds[index]}>
                  {team} / {termRoles[index]}
                </MenuItem>
              ))}
            </Select>
            )}
          </Typography>
          <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
            <b>Last Updated:</b> {noteUpdateBy[0] && noteUpdateDate[0]
              ? `${noteUpdateBy[0].split(":")[1]} on ${dayFormat(noteUpdateDate[0], "monthDDYYYY")}`
              : ""}
          </Typography>
          <TextField
            id="teamTermMemberNotes"
            variant="outlined"
            multiline
            fullWidth
            
            label="Note"
            margin="normal"
            name="Note"
            rows={10}
            className={classes.textFieldStyle}
            defaultValue={note}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
              classes: {                
                input: classes.textFieldInput,
              },
              style: {
                backgroundColor: "#EFEFEF",
              },
            }}
            onMouseDown={(e) => e.preventDefault()}
          />
          <Typography 
            variant="h3" 
            style={{ 
              fontSize: 16,
              textAlign: 'left',
              marginBottom: 5,
              marginTop: 15 
            }}
          >
            Did member complete the term?
            <span style={{ marginLeft: "145px" }}>
              <b>{completed[0] ? "Yes" : "No"}</b>
            </span>
          </Typography>
          <Typography 
            variant="h3" 
            style={{ 
              fontSize: 16,
              textAlign: 'left',
              marginBottom: 5,
              marginTop: 15 
            }}
          >
            Does member have to apply to next term?
            <span style={{ marginLeft: "80px" }}>
              <b>{applyNextTerm[0] ? "Yes" : "No"}</b>
            </span>
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleClose}
              >
                Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
